module.exports = __webpack_public_path__ + "img/galardon1.ff8b3057.png";